/**
 * Constant containing the id of the currently build version.
 */
export type Version = string;

export const VersionProvider: {
  provide: string;
  useValue: Version;
} = {
  provide: 'version',
  useValue: 'v25.16.0-10-gddf4b6c',
};
